/* eslint-disable */
import React, { useState, useEffect } from 'react';
import Cookies from 'js-cookie';
import CryptoJS from 'crypto-js';
import { Grid, Typography, Box, TextField } from '@material-ui/core';
import MaterialTable from 'material-table';
import useDashboard from '../../../../hooks/useDashboard';
import useQuickBook from '../../../../hooks/useQuickBook';
import usePractice from '../../../../hooks/usePractice';
import InfoPopover from '../../../../components/InfoPopover/InfoPopover'; /* eslint-disable-next-line */
import InfoPopoverCommentsWrapper from '../../../../components/InfoPopoverCommentsWrapper';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
/* Modal */
import ArrowForwardIcon from '@material-ui/icons/ArrowForward';
import useStyles from '../../Main.style';
import SummaryInvoiceByCell from '../SummaryInvoiceByCell/SummaryInvoiceByCell';
import { Autocomplete } from '@material-ui/lab';

const MyPersonalPerformance = React.memo(function MyPersonalPerformance() {
  /* Modal */
  const key = 'iFrasCwdJh';
  const userCookie = Cookies.get('user');
  const defaultState = 'changeInStatus';
  const bytes = CryptoJS.AES.decrypt(userCookie, key);
  const loggedInUserData = JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
  const { getDashboardComments } = usePractice();
  const { getTotalPastDueInvoicesForAllCells, getProfitRevenue } = useQuickBook();
  const {
    getFileManagementMyCellTable,
    getMyCellInvoicingPerformance,
    getMyInvoicingPerformance,
    getMyLogiwareDetails,
    getMyPersonalPerformancePerChangeStatus,
    getFileManagementMyCellTablePerChangeStatus,
  } = useDashboard();
  const [summaryInvoiceByCellArr, setSummaryInvoiceByCellArr] = React.useState([]);
  const [myInvoicingPerformanceData, setMyInvoicingPerformanceData] = useState([]);
  const [fileManagementByCellList, setFileManagementByCellList] = useState([]);
  const [myCellInvoicingPerformanceData, setMyCellInvoicingPerformanceData] = useState([]);
  const [profitRevenueQbObjByCell, setProfitRevenueQbObjByCell] = React.useState([]);
  const [myLogiwareData, setMyLogiwareData] = useState([]);
  const [dashboardComments, setDashboardComments] = useState([]);
  const [statusToFetchMyPersonalPerformance, setStatusToFetchMyPersonalPerformance] = useState(
    defaultState,
  );
  const [statusToFetchMyCellPerformance, setStatusToFetchMyCellPerformance] = useState(
    defaultState,
  );
  const [shouldShowComponent, setShouldShowComponent] = useState(true);
  const loadPastDueInvoicesByCell = async () => {
    const pastDueInvoicesArr = await getTotalPastDueInvoicesForAllCells();
    setSummaryInvoiceByCellArr(pastDueInvoicesArr?.reportResult || []);
  };
  async function findParentObjectBySearchText(obj, searchText, parentObj = null) {
    if (typeof obj === 'object') {
      if (Array.isArray(obj)) {
        for (var i = 0; i < obj.length; i++) {
          var result = await findParentObjectBySearchText(obj[i], searchText, obj);
          if (result) {
            return result;
          }
        }
      } else {
        for (var prop in obj) {
          if (obj.hasOwnProperty(prop)) {
            var result = await findParentObjectBySearchText(obj[prop], searchText, obj);
            if (result) {
              return result;
            }
            if (
              typeof obj[prop] === 'string' &&
              obj[prop].toLowerCase().indexOf(searchText.toLowerCase()) !== -1
            ) {
              return { object: obj, parent: parentObj };
            }
          }
        }
      }
    }
    return null;
  }

  const formatTonumber = (data, styles) => {
    if (data === null) {
      return 'N/A';
    }

    if (!data || data?.length === 0) {
      return 'N/A';
    }
    const cleanedData = /[$,]/.test(data) ? data.replace(/[$,]/g, '') : data;
    const numberData = Number(cleanedData);
    if (numberData < 0) {
      // Format the number as a currency and apply custom formatting for negative values
      const formattedValue = `(-${Math.abs(numberData)})`;
      return <Typography className={styles.TableTextRed}>{formattedValue}</Typography>;
    }
    // Format positive numbers normally
    return `${numberData}`;
  };
  const formatToCustomNumber = (data, styles, type) => {
    if (data === null) {
      return 'N/A';
    }

    if (!data || data?.length === 0) {
      return 'N/A';
    }
    const cleanedData = /[$,]/.test(data) ? data.replace(/[$,]/g, '') : data;
    const numberData = Number(cleanedData);
    if (numberData < 0) {
      // Format the number as a currency and apply custom formatting for negative values
      const formattedValue = `(-${Math.abs(numberData)})`;
      return <Typography className={styles.TableTextRed}>{formattedValue + ' ' + type}</Typography>;
    }
    // Format positive numbers normally
    return `${numberData} ${type}`;
  };
  const formatToCustomerCurrency = (data, styles, type) => {
    if (data === null) {
      return 'N/A';
    }
    if (!data || data?.length === 0) {
      return 'N/A';
    }
    const cleanedData = /[$,]/.test(data) ? data.replace(/[$,]/g, '') : data;
    const numberData = Number(cleanedData);
    if (numberData < 0) {
      // Format the number as a currency and apply custom formatting for negative values
      const formattedValue = `(-$${Math.abs(numberData).toLocaleString(undefined, {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      })})`;
      return <Typography className={styles.TableTextRed}>{formattedValue + ' ' + type}</Typography>;
    }
    // Format positive numbers normally
    return `$${numberData.toLocaleString(undefined, {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    })} ${type}`;
  };
  const loadMyInvoicingPerformance = async () => {
    const myInvoicingPerformance = await getMyInvoicingPerformance({
      userName: loggedInUserData?.userName,
      userId: loggedInUserData?.id,
      countryTitle: loggedInUserData?.country?.countryValue,
    });
    setMyInvoicingPerformanceData(myInvoicingPerformance?.usersResult);
  };

  //My Personal Performance FILE MANAGEMENT Table
  const loadMyPersonalPerformanceFileManagementTable = async (
    statusToFetchMyPersonalPerformance,
  ) => {
    const myLogiwareDetails =
      statusToFetchMyPersonalPerformance == 'actualStatus'
        ? await getMyLogiwareDetails({
            userName: loggedInUserData?.userName,
            countryTitle: loggedInUserData?.country?.countryValue,
          })
        : await getMyPersonalPerformancePerChangeStatus({
            userName: loggedInUserData?.userName,
            countryTitle: loggedInUserData?.country?.countryValue,
          });
    setMyLogiwareData(myLogiwareDetails?.usersResult);
  };
  const loadProfitQb = async () => {
    let revenueValueByCell = 0;
    let revenuePrevYearValueByCell = 0;
    let profitValueByCell = 0;
    let profitPrevYearValueByCell = 0;

    const resultDataByCell = await getProfitRevenue({
      cellId: loggedInUserData?.cell?.qbId ? loggedInUserData?.cell?.qbId : null,
    });

    if (resultDataByCell) {
      revenueValueByCell = await findParentObjectBySearchText(
        resultDataByCell?.reportResultYtd,
        'Total Income',
      );
      revenuePrevYearValueByCell = await findParentObjectBySearchText(
        resultDataByCell?.reportResultPrevYear,
        'Total Income',
      );
      profitValueByCell = await findParentObjectBySearchText(
        resultDataByCell?.reportResultYtd,
        'Net Income',
      );

      profitPrevYearValueByCell = await findParentObjectBySearchText(
        resultDataByCell?.reportResultPrevYear,
        'Net Income',
      );

      setProfitRevenueQbObjByCell(
        loggedInUserData?.cell?.qbId
          ? {
              revenueValueByCell: revenueValueByCell?.parent[1]?.value,
              revenuePrevYearValueByCell: revenuePrevYearValueByCell?.parent[1]?.value,
              profitValueByCell: profitValueByCell?.parent[1]?.value,
              profitPrevYearValueByCell: profitPrevYearValueByCell?.parent[1]?.value,
            }
          : [],
      );
    }
  };

  const loadDashboardCommentsDetails = async () => {
    const result = await getDashboardComments();
    if (result) {
      setDashboardComments(result?.usersResult);
    }
  };
  const loadManagementMyCellList = async (statusToFetchMyCellPerformance) => {
    //
    const managementMyCellList =
      statusToFetchMyCellPerformance == 'actualStatus'
        ? await getFileManagementMyCellTable({
            cellValue: loggedInUserData?.cell?.cellValue,
            countryTitle: loggedInUserData?.country?.countryValue,
          })
        : await getFileManagementMyCellTablePerChangeStatus({
            cellValue: loggedInUserData?.cell?.cellValue,
            countryTitle: loggedInUserData?.country?.countryValue,
          });
    setFileManagementByCellList(managementMyCellList?.usersResult);
  };

  const loadMyCellInvoicingPerformance = async () => {
    const myCellInvoicingPerformance = await getMyCellInvoicingPerformance({
      cellValue: loggedInUserData?.cell?.cellValue,
      countryTitle: loggedInUserData?.country?.countryValue,
      cellId: loggedInUserData?.cellId,
    });
    setMyCellInvoicingPerformanceData(myCellInvoicingPerformance?.usersResult || []);
  };

  useEffect(() => {
    loadDashboardCommentsDetails(); /* eslint-disable-next-line */
  }, []);

  useEffect(() => {
    const condition = true;
    setShouldShowComponent(condition);
  }, []);
  useEffect(() => {
    loadManagementMyCellList(statusToFetchMyCellPerformance);
  }, []);

  useEffect(() => {
    loadMyPersonalPerformanceFileManagementTable(statusToFetchMyPersonalPerformance);
  }, []);

  useEffect(() => {
    loadPastDueInvoicesByCell();
  }, []);

  useEffect(() => {
    loadMyCellInvoicingPerformance();
  }, []);

  useEffect(() => {
    loadMyInvoicingPerformance();
  }, []);

  useEffect(() => {
    loadProfitQb();
  }, []);

  const typeOptions = [
    { id: 'actualStatus', title: 'Actual Status' },
    { id: 'changeInStatus', title: 'Change in Status' },
  ];

  const classes = useStyles();
  return (
    <>
      <Grid container spacing={4}>
        <Grid item xs={12} className={classes.innercontent}>
          <Grid container style={{ height: '100%' }}>
            <Grid item xs={12}>
              <Grid container spacing={2}>
                <Grid item xs={12}>
                  <Typography variant="h5">
                    My Personal Performance:{' '}
                    {loggedInUserData?.firstName + ' ' + loggedInUserData?.lastName}
                  </Typography>
                </Grid>
                <Grid item xs={12} sm={12} md={6}>
                  <Box className={classes.innercontentWhite} height="100%">
                    <Box display="flex" justifyContent="space-between">
                      <Typography variant="h5" noWrap>
                        INVOICING
                      </Typography>
                      <InfoPopover
                        dashboardComments={dashboardComments}
                        dashboardSectionText="My Personal Performance"
                      />
                    </Box>
                    <Box mt={1} className={classes.TableUIV2}>
                      <MaterialTable
                        style={{ boxShadow: 'none' }}
                        options={{
                          toolbar: false,
                          draggable: false,
                          paging: false,
                          sorting: true,
                          pageSize: 20,
                          pageSizeOptions: [10, 20, 50, 100],
                          showTextRowsSelected: false,
                          toolbarButtonAlignment: 'right',
                          showFirstLastPageButtons: false,
                          actionsColumnIndex: -100,
                          emptyRowsWhenPaging: false,
                        }}
                        localization={{
                          pagination: {
                            labelRowsSelect: 'Rows',
                            labelRowsPerPage: 'Rows Per Page',
                          },
                        }}
                        title="File Management"
                        columns={[
                          {
                            title: loggedInUserData?.firstName + ' ' + loggedInUserData?.lastName,
                            field: 'metrix',
                            customSort: (a, b) => a?.metrix.localeCompare(b?.metrix),
                            render: (data) => (
                              <InfoPopoverCommentsWrapper
                                dashboardComments={dashboardComments}
                                section={data?.metrix}
                                title="My Personal Performance"
                              />
                            ),
                          },
                          {
                            title: new Date().getFullYear() + ' YTD',
                            field: 'ytd',
                            customSort: (a, b) => a.ytd.localeCompare(b.ytd),
                            render: (data) =>
                              data?.type == null
                                ? formatToCustomerCurrency(
                                    data?.ytd,
                                    classes,
                                    data?.subType ? data?.subType : '',
                                  )
                                : formatToCustomNumber(data?.ytd, classes, data?.type),
                          },
                          {
                            title: 'Ranking',
                            field: 'vectorranking',
                            customSort: (a, b) => a.vectorRank.localeCompare(b.vectorRank),
                            render: (data) => (
                              <span
                                className={
                                  data?.vectorRank ==
                                  Math.max(...myInvoicingPerformanceData.map((o) => o?.vectorRank))
                                    ? classes.vectorRankingRed
                                    : data?.vectorRank == 1
                                    ? classes.vectorRankingGreen
                                    : classes.vectorranking
                                }
                              >
                                {data?.vectorRank}
                              </span>
                            ),
                          },
                          {
                            title: 'Top Employee',
                            field: 'bestcell',
                            customSort: (a, b) => a.bestCell.localeCompare(b.bestCell),

                            render: (data) =>
                              data?.type == null
                                ? formatToCustomerCurrency(
                                    data?.bestCell,
                                    classes,
                                    data?.subType ? data?.subType : '',
                                  )
                                : formatToCustomNumber(data?.bestCell, classes, data?.type),
                          },
                          {
                            title: 'Last Year',
                            field: 'previousyear',
                            customSort: (a, b) => a.prevYear.localeCompare(b.prevYear),
                            render: (data) =>
                              data?.type == null
                                ? formatToCustomerCurrency(
                                    data?.prevYear,
                                    classes,
                                    data?.subType ? data?.subType : '',
                                  )
                                : formatToCustomNumber(data?.prevYear, classes, data?.type),
                          },
                        ]}
                        data={myInvoicingPerformanceData || []}
                      />
                    </Box>
                  </Box>
                </Grid>
                <Grid item xs={12} sm={12} md={6}>
                  <Box className={classes.innercontentWhite} height="100%">
                    <Box display="flex" justifyContent="space-between">
                      <Typography variant="h5" noWrap>
                        FILE MANAGEMENT
                      </Typography>
                      <Box
                        sx={{
                          width: 200,
                          border: '1px solid #003C6F',
                          borderRadius: '4px',
                          marginTop: '-8px',
                        }}
                      >
                        <Autocomplete
                          id="type"
                          options={typeOptions}
                          disablePortal
                          getOptionLabel={(option) => option?.title}
                          getOptionSelected={(option, value) => option?.id === value?.id}
                          value={
                            statusToFetchMyPersonalPerformance
                              ? typeOptions.find(
                                  (d) => d?.id === statusToFetchMyPersonalPerformance,
                                )
                              : null
                          }
                          onChange={(e, value) => {
                            setStatusToFetchMyPersonalPerformance(
                              value?.id ? value?.id : defaultState,
                            );
                            loadMyPersonalPerformanceFileManagementTable(
                              value?.id ? value?.id : defaultState,
                            );
                          }}
                          renderInput={(params) => (
                            <TextField {...params} label="Type" name="type" variant="outlined" />
                          )}
                          popupIcon={<ExpandMoreIcon />}
                        />
                      </Box>
                      <InfoPopover
                        dashboardComments={dashboardComments}
                        dashboardSectionText="My Personal Performance File Management"
                      />
                    </Box>

                    <Box mt={1} className={classes.TableUIV2}>
                      <MaterialTable
                        style={{ boxShadow: 'none' }}
                        options={{
                          toolbar: false,
                          draggable: false,
                          paging: false,
                          sorting: true,
                          pageSize: 20,
                          pageSizeOptions: [10, 20, 50, 100],
                          showTextRowsSelected: false,
                          toolbarButtonAlignment: 'right',
                          showFirstLastPageButtons: false,
                          actionsColumnIndex: -100,
                          emptyRowsWhenPaging: false,
                        }}
                        localization={{
                          pagination: {
                            labelRowsSelect: 'Rows',
                            labelRowsPerPage: 'Rows Per Page',
                          },
                        }}
                        title="File Management"
                        columns={[
                          {
                            title: loggedInUserData?.firstName + ' ' + loggedInUserData?.lastName,
                            field: 'cellf',
                            render: (data) => (
                              <InfoPopoverCommentsWrapper
                                dashboardComments={dashboardComments}
                                section={data?.metrix}
                                title="My Personal Performance File Management columns"
                              />
                            ),
                          },

                          {
                            title:
                              statusToFetchMyPersonalPerformance == 'actualStatus'
                                ? 'Today'
                                : new Date().getFullYear() + ' YTD',
                            field: 'ytd',
                            render: (data) => formatTonumber(data?.ytd, classes),
                          },
                          {
                            title: 'Ranking',
                            field: 'vectorranking',
                            render: (data) => (
                              <span
                                className={
                                  data?.vectorRank ==
                                  Math.max(...myLogiwareData.map((o) => o?.vectorRank))
                                    ? classes.vectorRankingRed
                                    : data?.vectorRank == 1
                                    ? classes.vectorRankingGreen
                                    : classes.vectorranking
                                }
                              >
                                {data?.vectorRank}
                              </span>
                            ),
                          },

                          {
                            title: 'Top Employee',
                            field: 'bestcell',
                            render: (data) => formatTonumber(data?.bestCell, classes),
                          },
                          {
                            title: 'Last Year',
                            field: 'previousyear',
                            render: (data) => formatTonumber(data?.prevYear),
                            hidden:
                              statusToFetchMyPersonalPerformance == 'actualStatus' ? true : false,
                          },
                        ]}
                        data={myLogiwareData || []}
                      />
                    </Box>
                  </Box>
                </Grid>
              </Grid>
            </Grid>
            <Grid item xs={12}>
              <Box
                display="flex"
                justifyContent="flex-end"
                alignItems="flex-end"
                height={1}
                mt={0.5}
              >
                <Box display="flex" justifyContent="flex-end" alignItems="center">
                  <Box>
                    <Typography variant="caption">View all</Typography>
                  </Box>
                  <Box className={classes.ViewAll}>
                    <ArrowForwardIcon />
                  </Box>
                </Box>
              </Box>
            </Grid>
          </Grid>
        </Grid>
        <Grid item xs={12}></Grid>
      </Grid>
      <Grid container spacing={4}>
        <Grid item xs={12} className={classes.innercontent}>
          <Grid container style={{ height: '100%' }}>
            <Grid item xs={12}>
              <Grid container spacing={2}>
                <Grid item xs={12}>
                  <Typography variant="h5">
                    My Cell's Performance: {'Cell ' + loggedInUserData?.cell?.cellTitle}
                  </Typography>
                </Grid>
                <Grid item xs={12} sm={12} md={6}>
                  <Box className={classes.innercontentWhite} height="100%">
                    <Box display="flex" justifyContent="space-between">
                      <Typography variant="h5" noWrap>
                        INVOICING
                      </Typography>
                      <InfoPopover
                        dashboardComments={dashboardComments}
                        dashboardSectionText={"My Cell's Performance"}
                      />
                    </Box>

                    {shouldShowComponent && (
                      <SummaryInvoiceByCell
                        reportArr={summaryInvoiceByCellArr}
                        myCellInvoiceArray={myCellInvoicingPerformanceData}
                        myProfitRevenue={profitRevenueQbObjByCell}
                        dashboardComments={dashboardComments}
                        dashboardSectionText={"My Cell's Performance"}
                      />
                    )}
                  </Box>
                </Grid>
                <Grid item xs={12} sm={12} md={6}>
                  <Box className={classes.innercontentWhite} height="100%">
                    <Box display="flex" justifyContent="space-between">
                      <Typography variant="h5" noWrap>
                        FILE MANAGEMENT
                      </Typography>
                      <Box
                        sx={{
                          width: 200,
                          border: '1px solid #003C6F',
                          borderRadius: '4px',
                          marginTop: '-8px',
                        }}
                      >
                        <Autocomplete
                          id="type"
                          options={typeOptions}
                          disablePortal
                          getOptionLabel={(option) => option?.title}
                          getOptionSelected={(option, value) => option?.id === value?.id}
                          value={
                            statusToFetchMyCellPerformance
                              ? typeOptions.find((d) => d?.id === statusToFetchMyCellPerformance)
                              : null
                          }
                          onChange={(e, value) => {
                            setStatusToFetchMyCellPerformance(value?.id ? value?.id : defaultState);
                            loadManagementMyCellList(value?.id ? value?.id : defaultState);
                          }}
                          renderInput={(params) => (
                            <TextField {...params} label="Type" name="type" variant="outlined" />
                          )}
                          popupIcon={<ExpandMoreIcon />}
                        />
                      </Box>
                      <InfoPopover
                        dashboardComments={dashboardComments}
                        dashboardSectionText="My Cell's Performance File Management"
                      />
                    </Box>

                    <Box mt={1} className={classes.TableUIV2}>
                      <MaterialTable
                        style={{ boxShadow: 'none' }}
                        options={{
                          toolbar: false,
                          draggable: false,
                          paging: false,
                          sorting: true,
                          pageSize: 20,
                          pageSizeOptions: [10, 20, 50, 100],
                          showTextRowsSelected: false,
                          toolbarButtonAlignment: 'right',
                          showFirstLastPageButtons: false,
                          actionsColumnIndex: -100,
                          emptyRowsWhenPaging: false,
                        }}
                        localization={{
                          pagination: {
                            labelRowsSelect: 'Rows',
                            labelRowsPerPage: 'Rows Per Page',
                          },
                        }}
                        title="File Management"
                        columns={[
                          {
                            title: 'Cell ' + loggedInUserData?.cell?.cellTitle,
                            field: 'cellf',
                            render: (data) => (
                              <InfoPopoverCommentsWrapper
                                dashboardComments={dashboardComments}
                                section={data?.metrix}
                                title="My Cell's Performance File Management columns"
                              />
                            ),
                          },
                          {
                            title:
                              statusToFetchMyCellPerformance == 'actualStatus'
                                ? 'Today'
                                : new Date().getFullYear() + ' YTD',
                            field: 'ytd',

                            render: (data) => formatTonumber(data?.ytd, classes),
                          },
                          {
                            title: 'Ranking',
                            field: 'vectorranking',
                            render: (data) => (
                              <span
                                className={
                                  data?.vectorRank ==
                                  Math.max(...fileManagementByCellList.map((o) => o?.vectorRank))
                                    ? classes.vectorRankingRed
                                    : data?.vectorRank == 1
                                    ? classes.vectorRankingGreen
                                    : classes.vectorranking
                                }
                              >
                                {data?.vectorRank}
                              </span>
                            ),
                          },
                          {
                            title: 'Top Cell',
                            field: 'bestcell',

                            render: (data) => formatTonumber(data?.bestCell, classes),
                          },
                          {
                            title: 'Last Year',
                            field: 'previousyear',
                            hidden: statusToFetchMyCellPerformance == 'actualStatus' ? true : false,
                            render: (data) =>
                              typeof data?.prevYear === 'string' && data.prevYear.includes('(') ? (
                                <Typography className={classes.TableTextRed}>
                                  {data?.prevYear}
                                </Typography>
                              ) : (
                                data?.prevYear
                              ),
                          },
                        ]}
                        data={fileManagementByCellList || []}
                      />
                    </Box>
                  </Box>
                </Grid>
              </Grid>
            </Grid>
            <Grid item xs={12}>
              <Box
                display="flex"
                justifyContent="flex-end"
                alignItems="flex-end"
                height={1}
                mt={0.5}
              >
                <Box display="flex" justifyContent="flex-end" alignItems="center">
                  <Box>
                    <Typography variant="caption">View all</Typography>
                  </Box>
                  <Box className={classes.ViewAll}>
                    <ArrowForwardIcon />
                  </Box>
                </Box>
              </Box>
            </Grid>
          </Grid>
        </Grid>
        <Grid item xs={12}></Grid>
      </Grid>
    </>
  );
});

export default MyPersonalPerformance;
